<template>
<div id="carousel">
    <div class="container">

        <h2 class="sub-headings">Gallery</h2>

        <div class="carousel-outer">
            <div class="carousel-wrapper flex" v-touch:swipe.left="swipeHandler"
                v-touch:swipe.right="swipeHandler">
                <div class="carousel-1 carousel-item">
                    <img src="../assets/projects/Rebar Detailing/Goldwyn Hotel.png" alt="Goldwyn Hotel">
                    <p><span>Goldwyn</span> Hotel</p>
                </div>
                <div class="carousel-2 carousel-item">
                    <img src="../assets/projects/Rebar Detailing/Baptist MD Anderson.png" alt="Baptist MD Anderson">
                    <p> Baptist MD <span>Anderson</span> </p>
                </div>
                <div class="carousel-3 carousel-item">
                    <img src="../assets/projects/Rebar Detailing/MARRIOTT LANAI.png" alt="MARRIOTT LANAI">
                    <p> Marriott <span>Lanai</span> </p>
                </div>
                <div class="carousel-4 carousel-item">
                    <img src="../assets/projects/Rebar Detailing/NAPLES SQ PHASE 2.png" alt="NAPLES SQ PHASE 2">
                    <p><span>NAPLES</span> SQ PHASE 2</p>
                </div>
                <div class="carousel-5 carousel-item">
                    <img src="../assets/projects/Rebar Detailing/Atlantic front.png" alt="Atlantic">
                    <p> Hotel <span>Atlantic</span> </p>
                </div>
                <div class="carousel-6 carousel-item">
                    <img src="../assets/projects/Rebar Detailing/Wynwood Dorsey.jpg" alt="Wynwood Dorsey">
                    <p>Wynwood <span>Dorsey</span></p>
                </div>
                <div class="carousel-7 carousel-item">
                    <img src="../assets/projects/Rebar Detailing/FIRST DELRAY.png" alt="FIRST DELRAY">
                    <p>FIRST <span>DELRAY</span></p>
                </div>
            </div>
        </div>

        <div class="carousel-dots-box flex">
            <div class="carousel-dot active" @click="handleClick" id="dot-1"></div>
            <div class="carousel-dot" @click="handleClick" id="dot-2"></div>
            <div class="carousel-dot" @click="handleClick" id="dot-3"></div>
            <div class="carousel-dot" @click="handleClick" id="dot-4"></div>
            <div class="carousel-dot" @click="handleClick" id="dot-5"></div>
            <div class="carousel-dot" @click="handleClick" id="dot-6"></div>
            <div class="carousel-dot" @click="handleClick" id="dot-7"></div>
        </div>
    </div>

</div>
</template>

<script>
import $ from 'jquery';

export default {
    data() {
        return {
            active: 1,
            interval: null
        }
    },
    methods: {
        handleClick(e) {
            this.active = Number( e.target.id[ e.target.id.length - 1 ] );
            $('.carousel-dot.active').removeClass('active');
            $('#dot-' + this.active).addClass('active');
            $('.carousel-wrapper').attr('class','carousel-wrapper flex show-' + this.active);

            clearInterval( this.interval );
            this.interval = setInterval( this.slideShow, 3500 );
        },
        swipeHandler (dir) {

            if ( ( this.active === 1 && dir === 'right') || ( this.active === 7 && dir === 'left') ) return;
            this.active = dir === 'right' ? this.active - 1 : this.active + 1;

            $('.carousel-dot.active').removeClass('active');
            $('#dot-' + this.active).addClass('active');
            $('.carousel-wrapper').attr('class','carousel-wrapper flex show-' + this.active);
        },
        slideShow() {

            this.active++;
            if(this.active === 8) this.active = 1;
            $('.carousel-dot.active').removeClass('active');
            $('#dot-' + this.active).addClass('active');
            $('.carousel-wrapper').attr('class','carousel-wrapper flex show-' + this.active);
        }
    },
    created () {
        this.active = 1;
        $('.carousel-dot.active').removeClass('active');
        $('#dot-1').addClass('active');
        $('.carousel-wrapper').attr('class','carousel-wrapper flex show-1');
        this.interval = setInterval( this.slideShow, 3500 );
    },
    destroyed () {
        clearInterval( this.interval );
    },
}

</script>

<style scoped>

#carousel
{
    padding-bottom: 75px;
}

.container { position: relative; }

.carousel-dots-box { justify-content: center; }

.carousel-dot
{
    height: 13px; width: 13px;
    background-color: #000;
    border-radius: 50%;
    cursor: pointer;
    margin: 0 4px;
}

.carousel-dot.active { background-color: #00c7ff; }

.carousel-outer
{
    margin-bottom: 50px;
    border: 2px solid #eff2f7;
    padding: 5px;
    background-color: #E8F0F2;
    box-shadow: 0 0 6px 1px rgb(0, 0, 0, 0.2);
}

.carousel-wrapper
{
    height: 100%; width: 100%;
    overflow: hidden;
}

.carousel-item
{
    height: auto; min-width: 100%;
    max-height: 600px;
    transition: margin 1s ease;
    position: relative;
}

.carousel-7 { transition: margin 2s ease; }

.carousel-item img
{
    height: auto;
    min-height: 100%;
    max-height: 100%;
    width: 100%;
}

.carousel-item p
{
    position: absolute;
    bottom: 30px; right: 0;
    font-size: 22px;
    font-weight: 900;
    text-transform: uppercase;
    font-style: italic;
    color: #fff;
    padding: 12px 50px 12px 40px;
    border-radius: 50px 0 0 50px;
    background-color: rgb(0, 0, 0, 0.8);
}

.carousel-item p span { color: #00c7ff; }

.carousel-wrapper.show-1 .carousel-1 { margin-left: 0; }

.carousel-wrapper.show-2 .carousel-1 { margin-left: -100%; }

.carousel-wrapper.show-3 .carousel-1 { margin-left: -200%; }

.carousel-wrapper.show-4 .carousel-1 { margin-left: -300%; }

.carousel-wrapper.show-5 .carousel-1 { margin-left: -400%; }

.carousel-wrapper.show-6 .carousel-1 { margin-left: -500%; }

.carousel-wrapper.show-7 .carousel-1 { margin-left: -600%; }

@media only screen and  (max-width: 767px)
{
    .container { width: calc(100% - 5px); overflow: hidden; }

    h2 { margin-bottom: 10px; }

    .carousel-item p { display: none; }
}

@media only screen and  (max-width: 425px)
{
    .carousel-item img { height: 225px; }
}

</style>